module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_7005.d09e8413.png";